/* The source page's own behaviour scripts (tracking, CheckoutChamp runtime and third-party players removed). */

  // ========================================
  // Other jQuery-dependent code (DOM manipulation, accordion, tabs, etc.)
  // ========================================
  $(document).ready(function () {
	/* provenBenefitsCard */
	let provenBenefitsCard = document.querySelectorAll(".js-proven-benefits-card");
	if (provenBenefitsCard) {
	  provenBenefitsCard.forEach(function (card) {
		void 0;
		card.addEventListener("click", function (event) {
		  let currentTarget = event.currentTarget;
		  void 0;
		  if (card) {
			if (! currentTarget.classList.contains('card-active')) {
			  currentTarget.classList.add('card-active');
			}
			else {
			  currentTarget.classList.remove('card-active');
			}
		  }
		}
							 );
	  }
								);
	}
	/* provenBenefitsCard */
	/* Accordion */
	let productAccordion = $('.js-accordion');
	productAccordion.each(function () {
	  let currentAccordion = $(this);
	  currentAccordion.find('.js-accordion-block .js-accordion-question').on('click', function (event) {
		let currentTarget = $(event.currentTarget);
		let currentBlock = currentTarget.closest('.js-accordion-block');
		let currentAnswer = currentBlock.find('.js-accordion-answer');
		if (currentBlock.hasClass('is-active-accordion')) {
		  currentBlock.removeClass('is-active-accordion');
		  currentAnswer.stop(true, true).slideUp();
		}
		else {
		  currentBlock.addClass('is-active-accordion');
		  currentAnswer.stop(true, true).slideDown(250);
		}
	  }
																			);
	}
						 );
	/* Accordion */
	/* Trusted Tabbing */
	let trustedTabWrappers = document.querySelectorAll(".js-tabbing-wrapper");
	if (trustedTabWrappers) {
	  trustedTabWrappers.forEach(tabWrapper => {
		let buttons = tabWrapper.querySelectorAll(".ja-tab-button");
		let details = tabWrapper.querySelectorAll(".ja-tab-detail");
		if (! buttons.length || ! details.length) 
		  return;
		buttons.forEach((button, index) => {
		  button.addEventListener("click", function (event) {
			event.preventDefault();
			if (button.classList.contains("active-tab-button")) 
			  return;
			buttons.forEach(btn => btn.classList.remove("active-tab-button"));
			details.forEach(detail => detail.classList.remove("active-tab-detail"));
			button.classList.add("active-tab-button");
			if (details[index]) {
			  details[index].classList.add("active-tab-detail");
			}
		  }
								 );
		}
					   );
	  }
								);
	}
	/* Trusted Tabbing */
	/* Timeline Animation */
	let timelineBlocks = document.querySelectorAll(".js-week-timeline-block");
	let lastScrollY = window.scrollY;
	function onScroll() {
	  let scrollY = window.scrollY;
	  let scrollingDown = scrollY > lastScrollY;
	  let activeZone = window.innerHeight * 0.6;
	  timelineBlocks.forEach((block, index) => {
		if (index === 0) 
		  return;
		let rect = block.getBoundingClientRect();
		let blockTop = rect.top;
		if (scrollingDown && blockTop <= activeZone) {
		  block.classList.add("timeline-active");
		}
		if (! scrollingDown && blockTop > activeZone) {
		  block.classList.remove("timeline-active");
		}
	  }
							);
	  lastScrollY = scrollY;
	}
	window.addEventListener("scroll", onScroll);
	window.addEventListener("resize", onScroll);
	onScroll();
	/* Timeline Animation */
	/* Based on product block selection update relative button and price block */
	let productBlocks = document.querySelectorAll(".urocontrol-product-block");
	let priceBlocks = document.querySelectorAll(".js-price-block");
	let productButtons = document.querySelectorAll(".js-product-button");
	function resetActiveStates() {
	  productBlocks.forEach(block => block.classList.remove("active-product"));
	  priceBlocks.forEach(block => block.style.display = "none");
	  productButtons.forEach(block => block.style.display = "none");
	}
	productBlocks.forEach((block, index) => {
	  block.addEventListener("click", () => {
		resetActiveStates();
		block.classList.add("active-product");
		if (priceBlocks[index]) {
		  priceBlocks[index].style.display = "flex";
		}
		if (productButtons[index]) {
		  productButtons[index].style.display = "block";
		}
	  }
							);
	}
						 );
	/* Based on product block selection update relative button and price block */
	/* Sticky productbar hide shown */
	let productStickyBar = document.querySelector(".js-product-sticky-bar");
	let customerReviewWrap = document.querySelector(".videos-slider");
	let windowLastScrollY = window.scrollY;
	let isStickyActive = false;
	function stickyAtcBarScroll(isInitial = false) {
	  let scrollY = window.scrollY;
	  let scrollingDown = scrollY > windowLastScrollY;
	  let rect = customerReviewWrap.getBoundingClientRect();
	  let viewportHeight = window.innerHeight;
	  if (isInitial && rect.top<= viewportHeight * 0.7																	
		 ) {
		productStickyBar.classList.add("sticky-bar-active");
		isStickyActive = true;
		windowLastScrollY = scrollY;
		return;
	  }
	  if (																		
		!isStickyActive &&																	
		scrollingDown &&																	
		rect.top <= viewportHeight * 0.7																	
	  ) {
		productStickyBar.classList.add("sticky-bar-active");
		isStickyActive = true;
	  }
	  if (																		
		isStickyActive &&																	
		!scrollingDown &&																	
		rect.top >= viewportHeight * 0.7																	
	  ) {
		productStickyBar.classList.remove("sticky-bar-active");
		isStickyActive = false;
	  }
	  windowLastScrollY = scrollY;
	}
	window.addEventListener("scroll", stickyAtcBarScroll);
	window.addEventListener("resize", stickyAtcBarScroll);
	window.addEventListener("load", () =>stickyAtcBarScroll(true)) 
	/* Sticky productbar hide shown */
	/* Scroll To provided section Id */
	$("a[href^='#'].scrollto").click(function (e) {
	  let jump = $(this).attr('href');
	  let new_position = $(jump).offset();
	  let scroll = 100;
	  $('html, body').stop().animate({
		scrollTop: new_position.top + scroll
	  }
									 , 500, function () {
		let new_position = $(jump).offset();
		$('html, body').stop().animate({
		  scrollTop: new_position.top + scroll
		}
									   , 500);
	  }
									);
	  e.preventDefault();
	}
									);
	/* Scroll To provided section Id */
	/* Hotspot button on hover desktop current popover and on mobile open on click */
	let hotspotButtons = document.querySelectorAll(".js-hotspot-button");
	function visibleHotspotpopOver(hotspotButton, hotspotPopover) {
	  let rect = hotspotButton.getBoundingClientRect();
	  let rectParent = hotspotButton.closest(".js-hotspot");
	  let popoverOffsetHeight = hotspotPopover.offsetHeight;
	  let rectTop = Math.max(rect.top, 0);
	  if (rectTop > popoverOffsetHeight) {
		rectParent.classList.remove("bottom");
		rectParent.classList.add("top");
	  }
	  else {
		rectParent.classList.remove("top");
		rectParent.classList.add("bottom");
	  }
	}
	function resetHotspot(rectParent) {
	  rectParent.classList.remove("top", "bottom");
	}
	hotspotButtons.forEach(hotspotButton => {
	  let rectParent = hotspotButton.closest(".js-hotspot");
	  let hotspotPopover = rectParent.querySelector(".js-hotspot-popover");
	  if (! hotspotPopover) 
		return;
	  function bindDesktop() {
		hotspotButton.addEventListener("mouseenter", () => {
		  visibleHotspotpopOver(hotspotButton, hotspotPopover);
		}
									  );
		hotspotButton.addEventListener("mouseleave", () => {
		  resetHotspot(rectParent);
		}
									  );
	  }
	  function bindMobile() {
		hotspotButton.addEventListener("click", (e) => {
		  e.preventDefault();
		  if (rectParent.classList.contains("top") || rectParent.classList.contains("bottom")) {
			resetHotspot(rectParent);
		  }
		  else {
			visibleHotspotpopOver(hotspotButton, hotspotPopover);
		  }
		}
									  );
	  }
	  function initHotspot() {
		if (window.innerWidth >= 769) {
		  bindDesktop();
		}
		else {
		  bindMobile();
		}
	  }
	  initHotspot();
	}
						  );
	document.addEventListener("click", function (e) {
	  document.querySelectorAll(".js-hotspot").forEach(hotspot => {
		const button = hotspot.querySelector(".js-hotspot-button");
		const popover = hotspot.querySelector(".js-hotspot-popover");
		if (! button || ! popover) 
		  return;
		if (button.contains(e.target) || popover.contains(e.target)) 
		  return;
		hotspot.classList.remove("top", "bottom");
	  }
													  );
	}
							 );
	/* Hotspot button on hover desktop current popover and on mobile open on click */
	/* Sticky Header */
	let stickyHeader = document.querySelector(".lovy-header");
	let headerlastScrollY = window.scrollY;
	function handleStickyHeader() {
	  let scrollY = window.scrollY;
	  let scrollingUp = scrollY < headerlastScrollY;
	  if (scrollingUp) {
		stickyHeader.classList.add("sticky-active");
	  }
	  else {
		stickyHeader.classList.remove("sticky-active");
	  }
	  headerlastScrollY = scrollY;
	}
	window.addEventListener("scroll", handleStickyHeader);
	window.addEventListener("resize", handleStickyHeader);
	/* Sticky Header */
  }
				   );

;

  /* Based on current date add delivery date on window load  */
  window.addEventListener("load", function () {
	let orderCreatedData = document.querySelector('.js-date-text');
	if (orderCreatedData) {
	  void 0;
	  let dateObj = new Date();
	  let minExpectedDelay = 10;
	  let maxExpectedDelay = 12;
	  let minExpectedDate = new Date(dateObj);
	  minExpectedDate.setDate(dateObj.getDate() + minExpectedDelay);
	  let maxExpectedDate = new Date(dateObj);
	  maxExpectedDate.setDate(dateObj.getDate() + maxExpectedDelay);
	  function formatPrettyDate(d) {
		let day = d.getDate();
		let month = d.toLocaleString("en-US", {
		  month: "long"}
									);
		let suffix = (n => {
		  if (n > 3 && n < 21) 
			return "th";
		  switch (n % 10) {
			case 1:
			  return "st";
			case 2:
			  return "nd";
			case 3:
			  return "rd";
			default:
			  return "th";
		  }
		}
					 )(day);
		return `${month}
${day}
${suffix}
`;
	  }
	  let startText = formatPrettyDate(minExpectedDate);
	  let endText = formatPrettyDate(maxExpectedDate);
	  orderCreatedData.textContent = `${endText}
.`;
	}
  }
						 );

;

  /* scrollLink smooth scroll */
  document.addEventListener("DOMContentLoaded", function () {
	const scrollLink = document.getElementById("iiftgol");
	if (! scrollLink) 
	  return;
	scrollLink.addEventListener("click", function (e) {
	  e.preventDefault();
	  const target = document.querySelector(this.getAttribute("href"));
	  if (! target) 
		return;
	  target.scrollIntoView({
		behavior: "smooth", block: "start"}
						   );
	}
							   );
  }
						   );

;

  /* Preselect 2nd product on load */
  document.addEventListener("DOMContentLoaded", function () {
	const productBlocks = document.querySelectorAll(".urocontrol-product-block");
	if (productBlocks[1]) {
	  productBlocks[1].click();
	}
  }
						   );

;

  /* Marquee animation */
  (function () {
	'use strict';
	const marquee = document.getElementById("marquee-c");
	if (! marquee) 
	  return;
	const speed = 1.5;
	let animationId = null;
	function setup() {
	  const items = Array.from(marquee.children);
	  if (! items.length) 
		return;
	  const wrapperWidth = marquee.parentElement.offsetWidth;
	  let currentWidth = marquee.scrollWidth;
	  while (currentWidth < wrapperWidth * 3) {
		items.forEach(item => {
		  var lvc = item.cloneNode(true), lvo = item.querySelectorAll('img[sizes]'); lvc.querySelectorAll('img[sizes]').forEach(function (m, i) { if (lvo[i] && lvo[i].offsetWidth) m.sizes = lvo[i].offsetWidth + 'px'; }); marquee.appendChild(lvc);
		}
					 );
		currentWidth = marquee.scrollWidth;
	  }
	  startAnimation();
	}
	function startAnimation() {
	  let position = 0;
	  const computedStyle = getComputedStyle(marquee);
	  const gap = parseFloat(computedStyle.gap || 0);
	  const firstItem = marquee.children[0];
	  const itemFullWidth = firstItem.offsetWidth + gap;
	  function scroll() {
		position -= speed;
		if (Math.abs(position) >= itemFullWidth) {
		  marquee.appendChild(marquee.children[0]);
		  position += itemFullWidth;
		}
		marquee.style.transform = 'translate3d(' + position + 'px, 0, 0)';
		animationId = requestAnimationFrame(scroll);
	  }
	  animationId = requestAnimationFrame(scroll);
	}
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', setup);
	}
	else {
	  requestAnimationFrame(setup);
	}
  }
  )();

;

  void 0;

;

  /**
   * Swiper.js Slider Implementation
   * Replaces Slick Carousel to fix iOS rendering issues
   */
  (function() {
	'use strict';
	// Detect iOS
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	/**
      * Find custom UI elements (arrows, dots) in wrapper
      */
	function findCustomUI(sliderEl, config) {
	  const wrapper = sliderEl.closest('.enabled-custom-arrow');
	  const result = {
		wrapper };
	  if (!wrapper) return result;
	  if (config.navigation) {
		result.prevArrow = wrapper.querySelector('.cus-arrow .swiper-button-prev');
		result.nextArrow = wrapper.querySelector('.cus-arrow .swiper-button-next');
	  }
	  if (config.pagination) {
		result.pagination = wrapper.querySelector('.swiper-pagination');
	  }
	  return result;
	}
	/**
      * Toggle visibility of arrows and dots based on slide count
      */
	function toggleArrowsAndDots(swiper) {
	  try {
		const wrapper = swiper.el.closest('.enabled-custom-arrow');
		if (!wrapper) return;
		const slidesPerView = swiper.params.slidesPerView === 'auto' 
		? swiper.slides.length 
		: swiper.params.slidesPerView;
		const shouldHide = swiper.slides.length <= slidesPerView;
		// Toggle arrows
		if (swiper.params.navigation) {
		  const arrowContainer = wrapper.querySelector('.cus-arrow');
		  if (arrowContainer) {
			arrowContainer.classList.toggle('hide-arrows', shouldHide);
		  }
		}
		// Toggle dots
		if (swiper.params.pagination) {
		  const arrowContainer = wrapper.querySelector('.cus-arrow');
		  const pagination = wrapper.querySelector('.swiper-pagination');
		  if (arrowContainer && pagination) {
			arrowContainer.classList.toggle('hide-dots', shouldHide);
		  }
		}
	  }
	  catch (e) {
		console.error('Error toggling arrows/dots:', e);
	  }
	}
	/**
      * Initialize a single Swiper instance
      */
	function initSwiper(selector, config) {
	  const el = document.querySelector(selector);
	  if (!el) {
		console.warn(`Swiper element not found: ${selector}
`);
		return null;
	  }
	  // Find custom UI elements
	  const ui = findCustomUI(el, config);
	  // Build Swiper config
	  const swiperConfig = {
		// Core settings
		slidesPerView: config.slidesPerView || 1,
		slidesPerGroup: config.slidesPerGroup || 1,
		spaceBetween: config.spaceBetween || 0,
		speed: config.speed || 300,
		loop: config.loop || false,
		autoplay: config.autoplay || false,
		// Behavior settings
		watchOverflow: config.watchOverflow !== undefined ? config.watchOverflow : true,
		centerInsufficientSlides: config.centerInsufficientSlides || false,
		slideToClickedSlide: false,
		grabCursor: true,
		// Navigation
		navigation: config.navigation ? {
		  nextEl: ui.nextArrow || '.swiper-button-next',
		  prevEl: ui.prevArrow || '.swiper-button-prev',
		}
		: false,
		// Pagination
		pagination: config.pagination ? {
		  el: ui.pagination || '.swiper-pagination',
		  clickable: true,
		  dynamicBullets: false,
		}
		: false,
		// Touch settings
		touchRatio: 1,
		touchAngle: 45,
		threshold: 5,
		longSwipesMs: 300,
		longSwipesRatio: 0.5,
		followFinger: true,
		allowTouchMove: true,
		touchStartPreventDefault: true,
		shortSwipes: true,
		longSwipes: true,
		// Prevent partial slides
		freeMode: false,
		freeModeSticky: false,
		freeModeMomentum: false,
		// Accessibility
		a11y: {
		  enabled: true,
		  prevSlideMessage: 'Previous slide',
		  nextSlideMessage: 'Next slide',
		}
		,
		// Responsive breakpoints
		breakpoints: config.breakpoints || {
		}
		,
		// Events
		on: {
		  init: function() {
			toggleArrowsAndDots(this);
		  }
		  ,
		  resize: function() {
			toggleArrowsAndDots(this);
		  }
		  ,
		  breakpoint: function() {
			toggleArrowsAndDots(this);
		  }
		  ,
		  update: function() {
			toggleArrowsAndDots(this);
		  }
		  ,
		  slideChange: function() {
			toggleArrowsAndDots(this);
		  }
		}
	  };
	  // Initialize Swiper
	  try {
		const swiper = new Swiper(el, swiperConfig);
		void 0;
		return swiper;
	  }
	  catch (e) {
		console.error(`✗ Swiper init failed: ${selector}
`, e);
		return null;
	  }
	}
	/**
      * Initialize product gallery (nav + thumbnail pair)
      */
	function initProductPair() {
	  const wraps = document.querySelectorAll('.js-main-product-wrap');
	  wraps.forEach(wrap => {
		const navEl = wrap.querySelector('.js-nav-product-slider');
		const thumbEl = wrap.querySelector('.js-thumbnail-product-slider');
		if (!navEl || !thumbEl) return;
		// Check if already initialized
		if (navEl.swiper || thumbEl.swiper) return;
		// Initialize main nav slider first
		const navSwiper = new Swiper(navEl, {
		  slidesPerView: 1,
		  slidesPerGroup: 1,
		  spaceBetween: 0,
		  speed: 300,
		  loop: false,
		  autoplay: false,
		  navigation: false,
		  pagination: false,
		  touchRatio: 1,
		  allowTouchMove: true,
		  watchOverflow: true,
		  effect: 'slide',
		}
									);
		// Create navigation buttons for thumbnail slider
		const prevBtn = document.createElement('div');
		prevBtn.className = 'swiper-button-prev';
		prevBtn.innerHTML = '<svg class="flip" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false" id="ivmtjvf"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
		const nextBtn = document.createElement('div');
		nextBtn.className = 'swiper-button-next';
		nextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false" id="ivmtjvf"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
		// Append buttons to thumbnail slider
		thumbEl.appendChild(prevBtn);
		thumbEl.appendChild(nextBtn);
		// Initialize thumbnail slider with link to nav
		const thumbSwiper = new Swiper(thumbEl, {
		  slidesPerView: 5,
		  slidesPerGroup: 1,
		  spaceBetween: 10,
		  speed: 300,
		  loop: false,
		  autoplay: false,
		  slideToClickedSlide: true,
		  watchSlidesProgress: true,
		  watchOverflow: true,
		  touchRatio: 1,
		  allowTouchMove: true,
		  grabCursor: true,
		  navigation: {
			nextEl: nextBtn,
			prevEl: prevBtn,
		  }
		  ,
		  breakpoints: {
			// >= 320px
			320: {
			  slidesPerView: 5,
			  slidesPerGroup: 1,
			  spaceBetween: 8,
			}
			,
			// >= 768px
			768: {
			  slidesPerView: 5,
			  slidesPerGroup: 1,
			  spaceBetween: 10,
			}
			,
			// >= 1025px
			1025: {
			  slidesPerView: 5,
			  slidesPerGroup: 1,
			  spaceBetween: 10,
			}
		  }
		  ,
		  on: {
			click: function(swiper, event) {
			  // Sync nav to clicked thumbnail
			  const clickedIndex = swiper.clickedIndex;
			  if (clickedIndex !== undefined) {
				navSwiper.slideTo(clickedIndex);
			  }
			}
		  }
		}
									  );
		// Sync nav changes to thumbs
		navSwiper.on('slideChange', function() {
		  thumbSwiper.slideTo(navSwiper.activeIndex);
		}
					);
		void 0;
	  }
				   );
	}
	/**
      * Slider configurations
      */
	const SLIDER_CONFIGS = [
	  {
		selector: '.js-benefits-slider',
		config: {
		  slidesPerView: 1,
		  slidesPerGroup: 1,
		  spaceBetween: 10,
		  navigation: true,
		  pagination: true,
		  loop: false,
		  autoplay: false,
		  watchOverflow: true,
		  centerInsufficientSlides: false,
		  breakpoints: {
			// >= 769px
			769: {
			  slidesPerView: 1,
			  slidesPerGroup: 1,
			  spaceBetween: 15,
			}
			,
			// >= 993px
			993: {
			  slidesPerView: 2,
			  slidesPerGroup: 2,
			  spaceBetween: 20,
			}
			,
			// >= 1200px
			1200: {
			  slidesPerView: 6,
			  slidesPerGroup: 6,
			  spaceBetween: 10,
			}
		  }
		}
	  }
	  ,
	  {
		selector: '.js-cus-review-slider',
		config: {
		  slidesPerView: 1,
		  slidesPerGroup: 1,
		  spaceBetween: 10,
		  navigation: true,
		  pagination: true,
		  loop: false,
		  autoplay: false,
		  watchOverflow: true,
		  centerInsufficientSlides: false,
		  breakpoints: {
			// >= 769px
			769: {
			  slidesPerView: 1,
			  slidesPerGroup: 1,
			  spaceBetween: 15,
			}
			,
			// >= 993px
			993: {
			  slidesPerView: 2,
			  slidesPerGroup: 1,
			  spaceBetween: 20,
			}
			,
			// >= 1200px
			1200: {
			  slidesPerView: 3,
			  slidesPerGroup: 1,
			  spaceBetween: 20,
			}
		  }
		}
	  }
	  ,
	  {
		selector: '.videos-slider',
		config: {
		  slidesPerView: 2,
		  slidesPerGroup: 1,
		  spaceBetween: 10,
		  navigation: false,
		  pagination: true,
		  loop: false,
		  autoplay: false,
		  watchOverflow: true,
		  centerInsufficientSlides: false,
		  breakpoints: {
			// >= 769px
			769: {
			  slidesPerView: 2,
			  slidesPerGroup: 1,
			  spaceBetween: 15,
			  pagination: true,
			}
			,
			// >= 993px
			993: {
			  slidesPerView: 2,
			  slidesPerGroup: 1,
			  spaceBetween: 20,
			  pagination: true,
			}
			,
			// >= 1200px
			1200: {
			  slidesPerView: 3,
			  slidesPerGroup: 1,
			  spaceBetween: 20,
			  pagination: false,
			}
		  }
		}
	  }
	];
	/**
      * Initialize all sliders sequentially
      */
	function initAllSliders() {
	  // Init product pair first
	  initProductPair();
	  // Init other sliders with slight delay for iOS
	  const delay = isIOS ? 100 : 50;
	  SLIDER_CONFIGS.forEach((item, index) => {
		setTimeout(() => {
		  initSwiper(item.selector, item.config);
		}
				   , delay * (index + 1));
	  }
							);
	}
	/**
      * Start initialization
      */
	function start() {
	  var maxAttempts = 50;
	  // how many times to retry
	  var interval = 200;
	  // retry every 200ms
	  var attempt = 0;
	  function tryInit() {
		if (typeof Swiper !== 'undefined') {
		  void 0;
		  initAllSliders();
		  return;
		}
		attempt++;
		if (attempt >= maxAttempts) {
		  console.error('Swiper library failed to load after retries.');
		  return;
		}
		console.warn('Swiper not ready. Retrying...', attempt);
		setTimeout(tryInit, interval);
	  }
	  tryInit();
	}
	// Initialize on DOM ready
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', start);
	}
	else {
	  start();
	}
  }
  )();

;

  (function () {
	var dpr      = Math.min(window.devicePixelRatio || 1, 2);
	var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || navigator.maxTouchPoints > 1;
	// ── Canvas ─────────────────────────────────────────────────────────────────
	var canvas = document.createElement("canvas");
	canvas.style.cssText =
	  "position:fixed;top:0;left:0;width:100%;height:100%;" +
	  "z-index:9999;pointer-events:none;will-change:transform;";
	document.body.appendChild(canvas);
	var ctx = canvas.getContext("2d", {
	  alpha: true }
							   );
	if (!ctx) return;
	var W, H, CX, CY, bL, bR;
	function resize() {
	  W  = window.innerWidth;
	  H  = window.innerHeight;
	  CX = W / 2;
	  CY = H / 2;
	  var hw = (isMobile ? W * 0.90 : W * 0.78) / 2;
	  bL = CX - hw;
	  bR = CX + hw;
	  canvas.width  = W * dpr | 0;
	  canvas.height = H * dpr | 0;
	  ctx.scale(dpr, dpr);
	}
	resize();
	// ── Palette ────────────────────────────────────────────────────────────────
	var COLORS = [
	  "#FF3A3A","#FF6B00","#FFD700","#39FF14","#00CFFF",
	  "#BF5FFF","#FF69B4","#FFFFFF","#FF4500","#00FF99",
	  "#FF1493","#FFA500","#7DF9FF","#ADFF2F","#FF6EC7"
	];
	var NC = COLORS.length;
	// ── Config ─────────────────────────────────────────────────────────────────
	var GRAVITY     = 0.06;
	var DRAG        = 0.983;
	var BURST_COUNT = 3;
	var BURST_DELAY = 110;
	// Reduced counts — quality over quantity, smoother on mobile
	var WAVE_SIZE   = isMobile ? [55, 35, 25] : [110, 70, 50];
	var LIFE_BASE   = isMobile ? 170 : 230;
	var particles = [];
	var shocks    = [];
	var running   = false;
	// ── Spawn — cache cos/sin at birth, never recompute ────────────────────────
	function spawnParticles(x, y, count) {
	  for (var i = 0; i < count; i++) {
		var angle = Math.random() * 6.2832;
		var speed = isMobile ? (2 + Math.random() * 5.5) : (3 + Math.random() * 7.5);
		var life  = (LIFE_BASE * (0.75 + Math.random() * 0.5)) | 0;
		var rs    = (Math.random() - 0.5) * 0.22;
		var rot   = Math.random() * 6.2832;
		// Pre-cache half-dimensions — fixed per particle, never change
		var hw    = (2.5 + Math.random() * 3) * 1.5;
		// half-width
		var hh    = hw * 0.45;
		// half-height (flat rect)
		particles.push({
		  x: x,   y: y,
		  vx: Math.cos(angle) * speed,
		  vy: Math.sin(angle) * speed,
		  hw: hw,  hh: hh,
		  col: COLORS[(Math.random() * NC) | 0],
		  rot: rot,
		  // Cache cos/sin — updated each frame with cheap incremental rotation
		  cr: Math.cos(rot),
		  sr: Math.sin(rot),
		  rs: rs,
		  life: life, max: life,
		  ef: 1,       // edgeFade
		}
					  );
	  }
	}
	function spawnShock(x, y) {
	  shocks.push({
		x: x, y: y, r: 0, maxR: Math.min((bR-bL)/2, H*0.45), op: 0.85 }
				 );
	}
	// ── Incremental rotation update — no cos/sin per frame ────────────────────
	// Uses small-angle rotation matrix: rotate cached (cr,sr) by rs each frame
	// Error accumulates but is invisible over ~200 frames
	function rotStep(p) {
	  var c = p.cr, s = p.sr, a = p.rs;
	  var ca = Math.cos(a), sa = Math.sin(a);
	  // computed ONCE per particle type at spawn? 
	  // Actually cache ca/sa on particle too
	  p.cr = c * p.ca - s * p.sa;
	  p.sr = s * p.ca + c * p.sa;
	}
	// ── Loop ───────────────────────────────────────────────────────────────────
	function loop() {
	  requestAnimationFrame(loop);
	  ctx.clearRect(0, 0, W, H);
	  // Shockwaves
	  var si, sw;
	  for (si = shocks.length - 1; si >= 0; si--) {
		sw = shocks[si];
		sw.r += 18;
		sw.op *= 0.87;
		if (sw.r > sw.maxR || sw.op < 0.01) {
		  shocks.splice(si, 1);
		  continue;
		}
		ctx.globalAlpha = sw.op;
		ctx.strokeStyle = "#FFB020";
		ctx.lineWidth   = sw.op * 2.5 + 1;
		ctx.beginPath();
		ctx.arc(sw.x, sw.y, sw.r, 0, 6.2832);
		ctx.stroke();
	  }
	  // ── Draw all particles in a SINGLE batched path per alpha bucket ──────
	  // Quantise alpha to 10 levels → only 10 globalAlpha changes max per frame
	  // instead of one per particle
	  var BUCKETS = 10;
	  // buckets[alphaIndex] = { a: float, paths: [[col, x0,y0,x1,y1,x2,y2,x3,y3], ...] }
	  // Actually: group by (alphaBucket, color) for maximum batching
	  // Simple approach: build one path per unique (bucket,color) combo
	  // Use a flat map: key = bucketIdx * NC + colorIdx  → path array
	  var batchFill  = new Array(BUCKETS * NC);
	  var batchAlpha = new Array(BUCKETS);
	  var i, p, a, bi, px, py, c, s, hw, hh;
	  for (i = 0; i < BUCKETS; i++) batchAlpha[i] = (i + 1) / BUCKETS;
	  var alive = 0;
	  for (i = particles.length - 1; i >= 0; i--) {
		p = particles[i];
		if (p.life <= 0) {
		  particles.splice(i, 1);
		  continue;
		}
		// Physics — no trig here
		p.vx *= DRAG;
		p.vy  = p.vy * DRAG + GRAVITY;
		p.x  += p.vx;
		p.y  += p.vy;
		// Rotation: incremental matrix multiply — no cos/sin call
		c = p.cr * p.ca - p.sr * p.sa;
		s = p.sr * p.ca + p.cr * p.sa;
		p.cr = c;
		p.sr = s;
		p.life--;
		if (p.y > H + 60) {
		  particles.splice(i, 1);
		  continue;
		}
		// Boundary
		if (p.x < bL) {
		  p.x = bL;
		  p.vx = 0;
		  p.ef = p.ef > 0.05 ? p.ef - 0.06 : 0;
		}
		else if (p.x > bR) {
		  p.x = bR;
		  p.vx = 0;
		  p.ef = p.ef > 0.05 ? p.ef - 0.06 : 0;
		}
		if (p.y < 0)  {
		  p.y = 0;
		  p.vy = p.vy > 0 ? p.vy : -p.vy * 0.3;
		}
		// Alpha — use sqrt LUT-style: just multiply
		a = (p.life / p.max) * p.ef;
		if (a <= 0.01) {
		  particles.splice(i, 1);
		  continue;
		}
		// Quantise to bucket
		bi = (a * BUCKETS - 0.001) | 0;
		// 0..9
		if (bi < 0) bi = 0;
		var key = bi * NC + (COLORS.indexOf(p.col));
		if (!batchFill[key]) batchFill[key] = {
		  a: batchAlpha[bi], col: p.col, pts: [] };
		// Push the 4 rotated corners
		hw = p.hw;
		hh = p.hh;
		c  = p.cr;
		s  = p.sr;
		px = p.x;
		py = p.y;
		batchFill[key].pts.push(
		  px + c*-hw - s*-hh, py + s*-hw + c*-hh,
		  px + c* hw - s*-hh, py + s* hw + c*-hh,
		  px + c* hw - s* hh, py + s* hw + c* hh,
		  px + c*-hw - s* hh, py + s*-hw + c* hh
		);
		alive++;
	  }
	  // Flush batches — one beginPath per (alpha,color) group
	  var key2, batch, pts, j;
	  for (key2 in batchFill) {
		batch = batchFill[key2];
		if (!batch) continue;
		pts = batch.pts;
		ctx.globalAlpha = batch.a;
		ctx.fillStyle   = batch.col;
		ctx.beginPath();
		for (j = 0; j < pts.length; j += 8) {
		  ctx.moveTo(pts[j],   pts[j+1]);
		  ctx.lineTo(pts[j+2], pts[j+3]);
		  ctx.lineTo(pts[j+4], pts[j+5]);
		  ctx.lineTo(pts[j+6], pts[j+7]);
		  ctx.closePath();
		}
		ctx.fill();
	  }
	  ctx.globalAlpha = 1;
	  if (!running && alive === 0 && shocks.length === 0) {
		canvas.remove();
	  }
	}
	// ── Pre-cache rotation step trig at spawn ──────────────────────────────────
	// Called after push so we can set ca/sa on the particle
	function cacheRotStep(p) {
	  p.ca = Math.cos(p.rs);
	  p.sa = Math.sin(p.rs);
	}
	// Patch spawnParticles to call cacheRotStep
	var _origSpawn = spawnParticles;
	spawnParticles = function (x, y, count) {
	  var before = particles.length;
	  _origSpawn(x, y, count);
	  for (var i = before; i < particles.length; i++) cacheRotStep(particles[i]);
	};
	// ── Flash ──────────────────────────────────────────────────────────────────
	function flash() {
	  var el = document.createElement("div");
	  el.style.cssText =
		"position:fixed;inset:0;pointer-events:none;z-index:9998;" +
		"background:radial-gradient(circle at 50% 50%," +
		"rgba(255,220,80,0.45) 0%,transparent 60%);" +
		"opacity:1;transition:opacity 0.4s ease;";
	  document.body.appendChild(el);
	  requestAnimationFrame(function () {
		el.style.opacity = "0";
	  }
						   );
	  setTimeout(function () {
		el.remove();
	  }
				 , 500);
	}
	// ── Orchestrate ────────────────────────────────────────────────────────────
	function runExplosion() {
	  particles.length = 0;
	  shocks.length    = 0;
	  flash();
	  running = true;
	  loop();
	  for (var w = 0; w < BURST_COUNT; w++) {
		(function (wave) {
		  setTimeout(function () {
			var ox = (Math.random() - 0.5) * 40;
			var oy = (Math.random() - 0.5) * 30;
			spawnShock(CX + ox, CY + oy);
			spawnParticles(CX + ox, CY + oy, WAVE_SIZE[wave]);
			if (wave === BURST_COUNT - 1) running = false;
		  }
					 , wave * BURST_DELAY);
		}
		)(w);
	  }
	}
	// ── Gate ───────────────────────────────────────────────────────────────────
	function maybeExplode() {
	  if (sessionStorage.getItem("discount_user") !== null) runExplosion();
	}
	if (document.readyState === "complete") maybeExplode();
	else window.addEventListener("load", maybeExplode);
  }
  )();

;

  function openNutritionPopup() {
	var el = document.getElementById("nutritionPopup");
	if (!el) return;
	var body = document.body;
	if (!body) {
	  document.addEventListener("DOMContentLoaded", function openWhenReady() {
		document.removeEventListener("DOMContentLoaded", openWhenReady);
		openNutritionPopup();
	  }
							   );
	  return;
	}
	if (el.parentElement !== body) {
	  body.appendChild(el);
	}
	el.style.display = "flex";
	body.style.overflow = "hidden";
  }
  function closeNutritionPopup() {
	var pop = document.getElementById("nutritionPopup");
	if (pop) pop.style.display = "none";
	if (document.body) document.body.style.overflow = "";
  }
  function goToSection(rawId) {
	var plain = String(rawId || "").trim().replace(/^#/, "");
	if (!plain) return;
	closeNutritionPopup();
	function findTarget(doc) {
	  if (!doc) return null;
	  var byId = doc.getElementById(plain);
	  if (byId) return byId;
	  if (typeof CSS !== "undefined" && CSS.escape) {
		try {
		  return doc.querySelector("#" + CSS.escape(plain));
		}
		catch (e) {
		}
	  }
	  return null;
	}
	function scrollToEl() {
	  var el = findTarget(document);
	  if (!el && window.parent && window.parent !== window) {
		try {
		  el = findTarget(window.parent.document);
		}
		catch (e) {
		  /* cross-origin parent */
		}
	  }
	  if (el) {
		el.scrollIntoView({
		  behavior: "smooth", block: "start" }
						 );
	  }
	}
	/* After closing the modal, layout updates; parent iframe needs a tick too */
	setTimeout(scrollToEl, 50);
  }

;
var items = document.querySelectorAll('#ih1vwj');
          for (var i = 0, len = items.length; i < len; i++) {
            (function(){
const e="",t="EXPIRED";let a="20",n="0",l="0",i="",s="";const r=this.querySelector("[data-js=countdown]"),o=this.querySelector("[data-js=countdown-endtext]"),d=this.querySelector("[data-js=countdown-day]"),u=this.querySelector("[data-js=countdown-hour]"),m=this.querySelector("[data-js=countdown-minute]"),p=this.querySelector("[data-js=countdown-second]"),h=this.querySelector("[data-js=countdown-interval]"),g=this.gjs_countdown_interval;let f;a=""!==a?a<10?"0"+a:a:"00",n=""!==n?n<10?"0"+n:n:"00",l=""!==l?l<10?"0"+l:l:"00",i=""!==i?i<10?"0"+i:i:"00";let b={hoursInput:a,minsInput:n,secsInput:l};for(var v in b);const y=this.getAttribute("timertype");let E;g&&g&&clearInterval(g);const C=(e,t,a,n)=>{d&&(d.innerHTML=e<10?"0"+e:e),u&&(u.innerHTML=t<10?"0"+t:t),m&&(m.innerHTML=a<10?"0"+a:a),p&&(p.innerHTML=n<10?"0"+n:n);const l={hoursInput:t<10?"0"+t:t,minsInput:a<10?"0"+a:a,secsInput:n<10?"0"+n:n};if("countUp"===y&&Object.entries(b).toString()===Object.entries(l).toString())return E=!0},w=e=>{h&&(h.innerHTML=e<10?"0"+e:e)},x=e=>{const a=(new Date).getTime();let n;n="countUp"!==y?f-a:a-f;const l=Math.floor(n/864e5),i=Math.floor(n%864e5/36e5),s=Math.floor(n%36e5/6e4),c=Math.floor(n%6e4/1e3);C(l,i,s,c),(n<0||E)&&(clearInterval(e),o&&(o.innerHTML=t,o.style.display="")),r.style.display="none"};if("blank"!==window.location.pathname){if(t&&t.includes("#")){const e=t.substring(1),a=document.getElementById(e);a.classList.contains("fk-hide-on-load")||(a.className+=" fk-hide-on-load",a.style.display="none")}if(e?f=new Date(e).getTime():i&&i>10?f=i:(a||n||l)&&("countUp"!==y?(f=new Date,f.setHours(f.getHours()+Number(a)),f.setMinutes(f.getMinutes()+Number(n)),f.setSeconds(f.getSeconds()+Number(l)),f=f.getTime()):f=(new Date).getTime()),f)if(o&&(o.style.display="none"),r.style.display="",window.Worker){const e=new Blob(['\n                                        onmessage = function(e) {\n                                            const timerType = e.data[1];\n                                            if (timerType !== "intervalTimer") {    \n                                            const countDownDate = e.data[0];\n                                            const moveTimer = (interval) => {\n                                                const now = new Date().getTime();\n                                                let distance;\n                                                if (timerType != "countUp" ) {\n                                                    distance = countDownDate - now;\n                                                } else {\n                                                    distance = now - countDownDate;\n                                                }\n\n                                                const days = Math.floor(distance / 86400000);\n                                                const hours = Math.floor((distance % 86400000) / 3600000);\n                                                const minutes = Math.floor((distance % 3600000) / 60000);\n                                                const seconds = Math.floor((distance % 60000) / 1000);\n\n                                                // If the count down is finished, write some text\n                                                if (distance < 0) {\n                                                    clearInterval(interval);\n                                                }\n                                                postMessage([days, hours, minutes, seconds, distance]);\n                                            };\n                                            const interval = setInterval(moveTimer, 1000);\n                                            moveTimer(interval);\n                                        } else {\n                                            let countDownDate = e.data[2];\n                                                const moveTimerForInterval = (interval) => {\n                                                let distance;\n                                                countDownDate = countDownDate -1;\n                                                distance = countDownDate;\n                                                if (distance < 0) {\n                                                    clearInterval(interval);\n                                                }\n                                                postMessage([distance]);\n                                            };\n                                            const interval = setInterval(moveTimerForInterval, e.data[3] * 1000);\n                                            moveTimerForInterval(interval); \n                                        } \n                                        }']),a=window.URL.createObjectURL(e),n=new Worker(a);n.postMessage([f,y,i,s]),n.onmessage=function(e){if("intervalTimer"!==y)if(e.data){const n=e.data[0],l=e.data[1],i=e.data[2],s=e.data[3],c=e.data[4];if(E=C(n,l,i,s),c<0||E){if(-1===t.indexOf(" ")&&-1!==t.indexOf(".")&&t.charAt(t.indexOf(".")+1)){let e=t;t.includes("https://")||t.includes("http://")?window.open(e,"_self"):window.open("https://"+e,"_self")}else if(t&&!t.includes("#")){if(o){o.innerHTML=t;var a=window.getComputedStyle(o.closest(".fk-countdown"),null);Array.from(a).forEach(function(e){o.style.setProperty(e,a.getPropertyValue(e),a.getPropertyPriority(e))}),o.style.display=""}}else{const e=new CustomEvent("openSectionTimer",{detail:t});window.dispatchEvent(e)}r.style.display="none"}}else C(0,0,0,0);else if(e.data){const e=i;i-=1,E=w(e),(e<0||E)&&(o&&(o.innerHTML=1,o.style.display=""),r.style.display="none")}else w(0)}}else if("intervalTimer"!==c){const e=setInterval(x,1e3);this.gjs_countdown_interval=e,x(e)}else{const e=setInterval(x,NaN);this.gjs_countdown_interval=e,(e=>{let a;i-=1,a=i,w(a),(a<0||E)&&(clearInterval(e),o&&(o.innerHTML=t,o.style.display="")),r.style.display="none"})(e)}else"intervalTimer"!==c?C(0,0,0,0):w(0)}
}.bind(items[i]))();
          }
;

            window.addEventListener('load', (function(){
                $("#loading").hide();
                $("body").removeClass("dom-pending");

                var lazyLoadThrottleTimeout;
                function recursiveOffsetParentTop(img) {
                    if (img.offsetParent) {
                        return img.offsetParent.offsetTop + recursiveOffsetParentTop(img.offsetParent);
                    } else {
                        return 0;
                    }
                }
                function lazyLoad() {
                    if (lazyLoadThrottleTimeout) {
                        clearTimeout(lazyLoadThrottleTimeout);
                    }
                    lazyLoadThrottleTimeout = setTimeout(function () {
                        const scrollTop = window.pageYOffset;
                        const buffer = 500;
                        var loaded = true;
                        //Lazy loading the images
                        var lazyLoad = [].slice.call(document.querySelectorAll(".fk-lazy"));
                        lazyLoad.forEach(function (element) {
                            if ($(element).is(':visible') && element.offsetTop + recursiveOffsetParentTop(element) < ((window.innerHeight + scrollTop) + buffer)) {
								if(element.dataset.src) {
                                    element.src = element.dataset.src;
                                }
								element.classList.remove("fk-lazy");
                            } else {
                                loaded = false;
                            }
                        });
                        if (loaded) {
                            document.removeEventListener("scroll", lazyLoad);
                            window.removeEventListener("resize", lazyLoad);
                            window.removeEventListener("orientationChange", lazyLoad);
                        }
                    }, 20);
                }

                document.addEventListener("scroll", lazyLoad);
                window.addEventListener("resize", lazyLoad);
                window.addEventListener("orientationChange", lazyLoad);
                lazyLoad();
            }), false);
        